import { take, put, call, fork, select, takeEvery, all } from 'redux-saga/effects';
import * as sagaController from '../../../../controllers/sagaController';
import * as types from '../../../../system/types';
import * as R from 'ramda';
import * as actions from './actions';
import * as rootActions from '../../../../system/actions';
import { Disposiciones, ExportarArchivoDisposiciones } from '../../../../api/Clients';
import { IResponse } from '../../../../models/IResponse';
import { AxiosResponse } from 'axios';
import { IDisposicionesResponse } from '../../../../models/IDisposicionesResponse';
import { IExportarArchivoResponse } from '../../../../models/IExportarArchivoResponse';

//#region DISPOSICIONES
export function* disposicionesRequestAsync(action: types.requestDisposicionesAction) {
    const response: IDisposicionesResponse = yield call(Disposiciones, action.data);
    // console.log(response);
    try {
        const {
            data,
            code,
            status,
            statusText,
            // headers,
            // config,
            // request,
        } = response;
        if (!R.isNil(data)) {
            yield sagaController.controlledStates(response, action.type, status);
        } else {
            yield sagaController.controlledStates(response, action.type, 400);
        }
    } catch (error) {
        console.log(error);
    }
}

export function* disposicionesSaga() {
    yield all([
        takeEvery(types.DISPOSICIONES_REQUEST, disposicionesRequestAsync)
    ])
}
//#endregion

//#region EXPORTAR ARCHIVO
export function* exportarArchivoDisposicionesRequestAsync(action: types.requestExportarArchivoDisposicionesAction) {
    const response: IExportarArchivoResponse = yield call(ExportarArchivoDisposiciones, action.data);
    // console.log(response);
    try {
        const {
            data,
            code,
            status,
            statusText,
            // headers,
            // config,
            // request,
        } = response;
        if (!R.isNil(data)) {
            yield sagaController.controlledStates(response, action.type, status);
        } else {
            yield sagaController.controlledStates(response, action.type, 400);
        }
    } catch (error) {
        console.log(error);
    }
}

export function* exportarArchivoDisposicionesSaga() {
    yield all([
        takeEvery(types.EXPORTARARCHIVODISPOSICIONES_REQUEST, exportarArchivoDisposicionesRequestAsync)
    ])
}
//#endregion